import axios from 'axios';

export const TIMEOUT = 15000;
console.log(process.env.REACT_APP_AUTH);
const instance = axios.create({
  baseURL: `${process.env.REACT_APP_AUTH}`,
  // baseURL: `http://127.0.0.1:3333/api/v1`,
  timeout: TIMEOUT
});
instance.interceptors.response.use(response => response, (error) => {
  if (error.response.status == 401) {
    // message.error('User session expired',2)
    // window.location = '/login'
    const btn = document.getElementById("sessionExpire")
    btn?.click()
    try {
      var x = document.getElementsByTagName("BODY")?.[0];
      x.style.overflowY = "scroll";
      x.style.paddingRight = "unset";
      var elements = document.getElementsByClassName('modal-backdrop');
      for (var i = 0; i <= elements?.length; i++) {
        elements[i].style.display = "none";
      }
    } catch (e) { }
    finally {

    }
  }
  return error
})
export default instance;
